// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollContributionsBreakdownRecordDto
 */
export interface IPayrollContributionsBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    invoice_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employer_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    plan_year_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    tax_year?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    contribution_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    memo?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    transaction_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IPayrollContributionsBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IPayrollContributionsBreakdownRecordDto interface.
 */
export function instanceOfIPayrollContributionsBreakdownRecordDto(value: object): value is IPayrollContributionsBreakdownRecordDto {
    return true;
}

export function IPayrollContributionsBreakdownRecordDtoFromJSON(json: any): IPayrollContributionsBreakdownRecordDto {
    return IPayrollContributionsBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IPayrollContributionsBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollContributionsBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'employee_contribution_amount': json['employee_contribution_amount'] == null ? undefined : json['employee_contribution_amount'],
        'employer_contribution_amount': json['employer_contribution_amount'] == null ? undefined : json['employer_contribution_amount'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_year_name': json['plan_year_name'] == null ? undefined : json['plan_year_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
        'memo': json['memo'] == null ? undefined : json['memo'],
        'transaction_date': json['transaction_date'] == null ? undefined : (new Date(json['transaction_date'])),
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IPayrollContributionsBreakdownRecordDtoToJSON(json: any): IPayrollContributionsBreakdownRecordDto {
    return IPayrollContributionsBreakdownRecordDtoToJSONTyped(json, false);
}

export function IPayrollContributionsBreakdownRecordDtoToJSONTyped(value?: IPayrollContributionsBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'employee_contribution_amount': value['employee_contribution_amount'],
        'employer_contribution_amount': value['employer_contribution_amount'],
        'plan_name': value['plan_name'],
        'plan_year_name': value['plan_year_name'],
        'plan_code': value['plan_code'],
        'tax_year': value['tax_year'],
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
        'memo': value['memo'],
        'transaction_date': value['transaction_date'] == null ? undefined : ((value['transaction_date']).toISOString()),
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

